import { Col } from 'antd';
import React from 'react';
import { v3FieldSortOptions } from '../fields/FieldSortOptions';
import { SearchFilter, SearchFilterContainer, SortByFilter, TagFilter } from '../filters';
export const PardotFieldSearch = ({ onChange, queryParams }) => React.createElement(SearchFilterContainer, null,
    React.createElement(Col, { span: 12 },
        React.createElement(SearchFilter, { onChange: onChange })),
    React.createElement(Col, { span: 12 }),
    React.createElement(Col, { span: 12 },
        React.createElement(TagFilter, { onChange: onChange })),
    React.createElement(Col, { className: 'align-right', span: 12 },
        React.createElement(SortByFilter, { defaultSortOption: v3FieldSortOptions[0], onChange: onChange, options: v3FieldSortOptions, queryParams: queryParams })));
